import { useState } from 'react';
import { getAnalysisData } from './useDashboardQueries';
import { useFeatureFlag } from '@harnessio/ff-react-client-sdk';
import { InsightPopup } from './InsightPopup';
import { createPortal } from 'react-dom';
import { useAnalytics } from '../../v2/third-party-integration/amplitude';
import { AMPLITUDE_EVENTS } from '../../constants';
import useProfileStore from '../core/UserProfileStore';
import { useTranslation } from 'react-i18next';

function AnalyzeIcon() {
  return (
    <div style={{marginTop:'5px'}}> 
    <svg width="18" height="18" viewBox="0 0 24 24">
      <path
        d="M12 2L14.2 9.8L22 12L14.2 14.2L12 22L9.8 14.2L2 12L9.8 9.8L12 2Z"
        fill="#1E6BFF"
      />
      <path
        d="M18 4L18.8 6.8L21.5 7.5L18.8 8.2L18 11L17.2 8.2L14.5 7.5L17.2 6.8L18 4Z"
        fill="#4DA3FF"
      />
      <path
        d="M6 15L6.5 16.8L8.2 17.3L6.5 17.8L6 19.5L5.5 17.8L3.8 17.3L5.5 16.8L6 15Z"
        fill="#6BB7FF"
      />
    </svg>
    </div>
  );
}

const fetchAnalysis = async (data: any, fields: any, operatorMap: any, locale: string) => {
  try {
    const dataArray = Array.isArray(data) ? data : [data];
    if (dataArray.length > 0) {
      const cleanedData = dataArray.map((item: any) => {
        const { color, ...rest } = item;
        return rest;
      });

      const rulesText = fields
        ?.flatMap(
          (field: any) =>
            field.threshold?.conditions?.map((condition: any) => {
              const readableOperator =
                operatorMap[condition.operator] || condition.operator;
              return `- If ${field.name} is ${readableOperator} ${condition.value}, treat it as "${condition.label}".`;
            }) || []
        )
        .join('\n');

      const analysisDataResult = await getAnalysisData({
        prompt:
          `You must strictly follow the interpretation rules below. Generate clear, end-user friendly insights from this car dealership dashboard. Highlight key issues, risks, and recommended actions. Keep the response short and actionable under 100 words. Do NOT refer to the data as "this dealership".` +
          (rulesText && `Interpretation rules: ${rulesText}`),
        dashboard: cleanedData,
        locale: locale || 'en_US',
      });

      return analysisDataResult;
    }
  } catch (error) {
    console.error('Error fetching analysis data:', error);
  }
};

export const AIAnalyze = ({ data, fields, operatorMap, dashboard }: any) => {
  const UNIFY_UI_ANALYZE = useFeatureFlag('UNIFY_UI_ANALYZE');
  const [result, setResult] = useState('Loading');
  const [showInsight, setShowInsight] = useState(false);
  const { trackEvent } = useAnalytics();
  const locale = useProfileStore((state) => state.locale);
  const { t } = useTranslation();

  const handleClick = async () => {
     trackEvent(AMPLITUDE_EVENTS.OPEN_AI_ANALYZE, {
          'Item': dashboard
        });
    setShowInsight(true);
    const result = (await fetchAnalysis(data, fields, operatorMap, locale)) as any;
    setResult(result);
  };
  return (
    <>
      {UNIFY_UI_ANALYZE && (
        <div>
          
          <button
            data-testid="insight-icon"
            style={{
              backgroundColor: 'transparent',
              color: '#1976d2',
              height: '24px',
              border: 'none',
              cursor: 'pointer',
            }}
            onClick={handleClick}
          >
            <AnalyzeIcon />
            {/*<span style={{ top: '-4px', left: '-3px', position: 'relative' }}>
              Analyze
            </span>*/}
          </button>
        </div>
      )}
      {showInsight && 
      createPortal(
        <InsightPopup
          text={result.replace(/\\n/g, '\n')}
          onClose={() => setShowInsight(false)}
          title={t('dashboard.insight.title') || ''}
          loadingPrefix={t('dashboard.insight.loadingPrefix') || ''}
          disclaimer={t('dashboard.insight.disclaimer') || ''}
        />,
        document.body
      )}
    </>
  );
};
